"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizePath = exports.sanitizeParameters = void 0;
/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
const constants_1 = require("./constants");
function sanitizeParameters(params, filterSet) {
    if (!params || !Object.keys(params).length) {
        return; // Return undefined to avoid empty objects in log
    }
    const safeParams = Object.assign({}, params);
    Object.keys(safeParams).forEach((key) => {
        const paramValue = safeParams[key];
        if ((filterSet.has(key) && paramValue) || constants_1.imsEmailRegex.test(paramValue) || isJWT(paramValue)) {
            safeParams[key] = 'REDACTED';
        }
    });
    return safeParams;
}
exports.sanitizeParameters = sanitizeParameters;
function isJWT(jwt) {
    let isValidJWT = constants_1.isJWTRegex.test(jwt);
    if (isValidJWT) {
        // Check whether header is a valid base64 encoded object
        try {
            const jwtHeader = jwt.substring(0, jwt.indexOf('.'));
            const base64DecodedHeader = typeof window === 'undefined' ? Buffer.from(jwtHeader, 'base64').toString('utf-8') : atob(jwtHeader);
            JSON.parse(base64DecodedHeader);
        }
        catch (error) {
            isValidJWT = false;
        }
    }
    return isValidJWT;
}
function sanitizePath(path) {
    // try to find all matching `/*`
    return path === null || path === void 0 ? void 0 : path.replace(/\/([^/]*)/g, (matched, pathSegment) => {
        if (isJWT(pathSegment)) {
            return '/REDACTED';
        }
        return matched;
    });
}
exports.sanitizePath = sanitizePath;
